import moment from 'moment';

import { fetchPost } from '../../providers/Fetch';
import { FLIGHT_PRODUCTS_REQUEST, FLIGHT_PRODUCTS_SUCCESS, FLIGHT_PRODUCTS_ERROR } from './types';

const flightProductsRequest = {
  type: FLIGHT_PRODUCTS_REQUEST,
};

const flightProductError = error => ({
  type: FLIGHT_PRODUCTS_ERROR,
  error,
});

const flightProductsSuccess = data => ({
  type: FLIGHT_PRODUCTS_SUCCESS,
  data,
});

export const flightProductsFetch = ({ date, flight }) => async (dispatch) => {
  dispatch(flightProductsRequest);
  try {
    const data = await fetchPost('/flight/products/operable/flights', {
      date: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      flight,
    });
    dispatch(flightProductsSuccess(data));
  } catch (e) {
    dispatch(flightProductError(e.message));
  }
};
